import React, { useEffect, useState } from "react";
import { Droppable, DroppableProps } from "react-beautiful-dnd";


/**
 * This component wraps the `Droppable` from `react-beautiful-dnd` to address 
 * compatibility issues with React 18's StrictMode. React 18 introduces 
 * intentional double rendering in development mode, which can cause 
 * `react-beautiful-dnd` to initialize refs incorrectly, leading to errors like 
 * "Unable to find draggable with id." 
 * 
 * By delaying the rendering of the `Droppable` until after the initial rendering
 * cycle using `requestAnimationFrame`, this ensures stable initialization of refs 
 * and prevents these errors.
 */

export const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));

    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
};
